import React from "react";
import Breadcrumbs from "../components/Breadcrumbs";
import incLogoNew from "../assets/inc-logo-new.webp";

const AboutUs: React.FC = () => {
  // Breadcrumb data
  const breadcrumbItems = [
    {
      label: "About Us",
      path: "/about-us",
    },
  ];

  return (
    <div className="flex flex-col">
      <main className="flex-grow">
        {/* Breadcrumbs */}
        <Breadcrumbs items={breadcrumbItems} />

        {/* About Us Content */}
        <div className="w-full pt-[15px] pb-[50px] bg-white">
          <div className="px-5 max-w-[1710px] mx-auto">
            <div className="flex pt-[40px] pb-[46px] flex-col lg:flex-row items-start gap-8">
              {/* Text Content - Left side on large screens */}
              <div className="flex-1">
                <h1 className="text-3xl md:text-[38px] font-light text-gray-800 mb-9">
                  About Us and Our Mission
                </h1>

                {/* Company Image - Shows on mobile, hidden on large screens */}
                <div className="lg:hidden mb-8 flex justify-center">
                  <img
                    src={incLogoNew}
                    alt="Inc. 5000 Fastest Growing Companies"
                    loading="lazy"
                  />
                </div>

                <div className="hidden lg:block lg:max-w-[360px] float-right">
                  <img
                    src={incLogoNew}
                    alt="Inc. 5000 Fastest Growing Companies"
                    loading="lazy"
                  />
                </div>

                <div className="space-y-[21px] text-[#202020] text-base leading-[26px] mb-[21px]">
                  <p>
                    <a
                      href="https://www.ppe.us/"
                      className="text-[#BA0C2F] hover:underline hover:text-[#BA0C2F]"
                    >
                      PPE.us
                    </a>{" "}
                    is leading distributor of personal protective equipment, and
                    is proud to have delivered over 50 million pieces of PPE
                    during the COVID-19 pandemic. We are a large supplier to
                    major government, enterprise, healthcare and education
                    organizations across North America using proven supply
                    chains, including Made in USA resources.
                  </p>

                  <p>
                    Our founder is a successful entrepreneur that has developed
                    and grown multiple companies, and recently joined the ranks
                    of the 2021 Inc. 5000 Fastest Growing Companies. He
                    encourages, and lives, a culture of passion, pride, and
                    living life to it's fullest.
                  </p>

                  <p>
                    Our mission is provide quality products to protect your team
                    and ensure their safety. We are your reliable partner for
                    your PPE needs.
                  </p>

                  <p>
                    We operate our company with integrity and empathy, and we
                    have a strong desire to provide unparalled support to our
                    customers. Demonstrating our core values, the quality of our
                    products are backed by a lifetime warranty - if there is an
                    issue, we will make it right, for life. Our company culture
                    embraces giving back to the community, which is we have
                    donated hundreds of thousands of masks to companies in need,
                    along with spearheading a nationwide PPE litter cleanup
                    program.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutUs;
